import { Component, ViewEncapsulation, Input, Renderer2, ChangeDetectorRef } from '@angular/core';
import { DispatchesService } from '../../shared/services/dispatches.service';
import { GlobalsService } from '../../shared/services/globals.service';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { DispatchAssignmentBus } from '@app/cp/shared/models/DispatchAssignmentBus';
import { DateFunctions } from '@app/cp/shared/static/date-functions';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { MessageType } from '@app/cp/shared/enums/MessageType';
import { PersonSel } from '@app/cp/shared/models/PersonSelBus';
import { ConfirmOutput } from '@app/cp/shared/models/ConfirmOutput';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { isEqualDate } from '@progress/kendo-date-math';
import { CRUDActions } from '@app/cp/shared/enums/CRUDActions';
import { CPDialogResult } from '@app/cp/shared/enums/CPDialogResult';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { UseFeatureFlagSet, IFeatureFlagSet } from '@app/cp/shared/decorators/featureflags/featureflagset-decorator';

@UseFeatureFlagSet()
@Component({
    selector: 'dispatch-assignments',
    templateUrl: './dispatch-assignments.component.html',
    styleUrls: ['./dispatch-assignments.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DispatchAssignmentsComponent extends BaseGridEditLineComponent<DispatchAssignmentBus, null, DispatchesService>  {
    compFeatureFlagSet: IFeatureFlagSet = this as any;

    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: DispatchesService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;
        this.disableCpSearchDialog();
        this.className = "v_DispatchAssignmentBus";
        this.appCode = "DispatchAssignments";
        this.appName = "Dispatch Assignments";
  }
    createForm() {
        this.editForm = new UntypedFormGroup({
            'dispatchAssignmentId': new UntypedFormControl(),
            'dispatchId': new UntypedFormControl(),
            'assignedPersonId': new UntypedFormControl(),
            'assignedPersonName': new UntypedFormControl(),
            'assignedDate': new UntypedFormControl(),
            'assignedStatusId': new UntypedFormControl('', Validators.required),
            'isPrimary': new UntypedFormControl(),
            'startDate': new UntypedFormControl(),
            'requireFieldValidation': new UntypedFormControl(),
            'assignedByPersonId': new UntypedFormControl(),
            'updateDt': new UntypedFormControl(),
            'updateUserId': new UntypedFormControl(),
            'insertDt': new UntypedFormControl(),
            'insertUserId': new UntypedFormControl()
        });

    }
    setForm() {
        this.editForm.patchValue({
            dispatchAssignmentId: this.selectedData.dispatchAssignmentId,
            dispatchId: this.selectedData.dispatchId,
            assignedPersonId: this.selectedData.assignedPersonId,
            assignedDate: this.selectedData.assignedDate,
            assignedStatusId: this.selectedData.assignedStatusId,
            isPrimary: this.selectedData.isPrimary,
            startDate: this.selectedData.startDate,
            requireFieldValidation: this.selectedData.requireFieldValidation,
            assignedByPersonId: this.selectedData.assignedByPersonId,
            updateDt: this.selectedData.updateDt,
            updateUserId: this.selectedData.updateUserId,
            insertDt: this.selectedData.insertDt,
            insertUserId: this.selectedData.insertUserId,
            assignedPersonName: this.selectedData.assignedPersonName
        });
    }
    @Input() canAdd: boolean = true;
    get canAddNow(): boolean {
        return (this.canAdd && this.canAddEdit)
    }
    protected getChangedObject(data: DispatchAssignmentBus) {
        let busObj: DispatchAssignmentBus = new DispatchAssignmentBus(data);
        busObj.setCommon(this.globals.userId, DateFunctions.getDateNow(), this.globals.companyId, this.globals.personId);
        busObj.setParentId(this._parentId);
   //     busObj.startDate = DateFunctions.getDateTimeWithUTCOffset(busObj.startDate);
        busObj.setBeforeSave();
        return busObj;
    }
    protected save(data: DispatchAssignmentBus) {
        let busObj: DispatchAssignmentBus = this.getChangedObject(data); // new DispatchAssignmentBus(data);
        //busObj.setCommon(this.globals.userId, DateFunctions.getDateNow(), this.globals.companyId, this.globals.personId);
        //busObj.setParentId(this._parentId);
        //busObj.startDate = DateFunctions.getDateTimeWithUTCOffset(busObj.startDate);
       // busObj.endDate = CommonFunctions.hasValue(busObj.endDate) ? DateFunctions.getDateTimeWithUTCOffset(busObj.endDate) : busObj.endDate;
        this.svc_data.saveDispatchAssignment(busObj).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {
                let dataObj: DispatchAssignmentBus = new DispatchAssignmentBus(info.primaryReturn);
                this.saveSuccess(dataObj);
                this.sendParentMessage(MessageType.getData, "assignments");
            }
            else {
                this.saveError(info.primaryReturn, info.message);
            }
        });
    }

    public assignedStatus(id: string) {
        return this.referenceData.dispAssignStatus.find(x => x.value === id);
    }
    assignedPersonChanged(e: any) {
        if (e) {
            this.selectedData.assignedPersonName = this.personName(e);
            this.editForm.patchValue({
                assignedPersonName:  this.personName(e)
            }
            )
        }
        this.checkValidPersonAssignment();
//        let person: PersonSel = this.referenceData.personsSel.find(s => s.value == e);
////        let person2: PersonSel[] = this.referenceData.personsSel.filter(s => CommonFunctions.hasArrayValue(s.timeOff));
//        let date: Date = new Date(this.editForm.value.startDate);
//        let timeOff = person.timeOff.find(s => isEqualDate(new Date(s.date),date));
////        let person3: PersonSel[] = this.referenceData.personsSel.filter(s => CommonFunctions.hasArrayValue(s.timeOff) && isEqualDate(testDate));
//        if (CommonFunctions.hasValue(timeOff)) {
//            let message: string = person.description;
//            if (timeOff.hours < 8) {
//                message += " has " + timeOff.hours.toString() + " hours scheduled off.Are you sure you want to continue?";
//            }
//            else {
//                message += " is scheduled off for the day.";
//            }
//            this.cnfShow(message, CRUDActions.None, null, "Scheduling Issue", "ASSIGN");

//        }
    }
    checkValidPersonAssignment() {
        let personId: any = this.editForm.value.assignedPersonId;

        let startDate: any = DateFunctions.getDate(this.editForm.value.startDate);
        if (CommonFunctions.hasValue(personId) && DateFunctions.isValidDate(startDate)) {
            let person: PersonSel = this.referenceData.personsSel.find(s => s.value == personId);

            let timeOff = person.timeOff.find(s => isEqualDate(new Date(s.date), startDate));
            if (CommonFunctions.hasValue(timeOff)) {
                let message: string = person.description;
                if (timeOff.hours < 8) {
                    message += " has " + timeOff.hours.toString() + " hours scheduled off. Are you sure you want to continue?";
                }
                else {
                    message += " is scheduled off for the day.";
                }
                this.cnfShow(message, CRUDActions.None, null, "Scheduling Issue", "ASSIGN");
            }
        }
    }
    startDateChanged(e: any) {
        this.editForm.patchValue({
            startDate: e
        });

    }
    confirmCustom(data: ConfirmOutput) {
        if (data.code === 'ASSIGN') {
            if (data.dialogResult === CPDialogResult.cancel ) {
                this.editForm.patchValue({
                    assignedPersonId: null,
                    assignedPersonName: null
               });
            }
        }
    }
    deleteIndividual(data: DispatchAssignmentBus) {
        if (data.hasId) {
            this.svc_data.deleteDispatchAssignment(data.dispatchAssignmentId).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError) {
                    this.deleteSuccess(data);
                    this.removeLocal(data);
                }
                else {
                    this.deleteError(data, info.message);
                }
            });
        }
        else {
            this.closeEditor();
        }
    }
    contactInfo(id: any) {
    }
    protected customAddNew(): boolean {
        this.sendParentMessage(MessageType.assignNewTech, null, null, null);
        return true;
    }
    processGridData() {
        if (this.hasGridData) {
            for (let i = 0; i < this.gridData.length; i++) {
                this.gridData[i].assignedPersonName = this.personName(this.gridData[i].assignedPersonId);
                this.gridData[i].assignedByPersonName = this.personName(this.gridData[i].assignedByPersonId);
                var upPerson = this.personFromUserId(this.gridData[i].updateUserId);
                if (upPerson) { this.gridData[i].updatePersonName = upPerson.description;}
            }
        }

    }
    protected validateData(data: DispatchAssignmentBus): Promise<BaseMessageInfo> {
        let info: BaseMessageInfo = new BaseMessageInfo();
        info.saveError = false;
        info.message = "";
        return this.svc_data.validate(data, "DispatchAssignment").toPromise().then(info => { return info });
        //return of(info)
        //    //.pipe(map(a => {
        //    //    info.saveError = false; info.message = "";
        //    //}))
        //    .toPromise()
        //    .then(a => { return info });
    }
    customCheckBoxChanged(e: any, dataItem, rowIndex, column, columnIndex) {
        if (column.field === "isPrimary") {
            this.editForm.patchValue({
                isPrimary: e.target.checked
            });

        }
        if (column.field === "requireFieldValidation") {
            this.editForm.patchValue({
                requireFieldValidation: e.target.checked
            });

        }
    }
}
